

























































































































































import { Component, Emit, Mixins } from 'vue-property-decorator'
import { SHUGYOU_KEITAI_IPPAN, KYUJITSU_KUBUN_TSUJO } from '@/tcw/constant/TcwConstant'
import { TcwAPIDate, TcwFormDate } from '@/tcw/domain/types'
import KintaiCardCommon from '../mixins/KintaiCardCommon.vue'
import LabelValueItem from '../atom/KintaiCardLabelValueItem.vue'

@Component({
  components: { LabelValueItem }
})
export default class KintaiCardWeekday extends Mixins(KintaiCardCommon) {
  @Emit()
  private clickDenchi(_day: TcwAPIDate): void {
    /** */
  }

  protected outputTime(value: TcwFormDate): string {
    return this.du.convertDateToStr(value, 'HH:mm')
  }
  private get koutsuhiStr(): string | null {
    const koutsuhi = this.koutsuhi?.goukeiKingaku
    if (typeof koutsuhi !== 'number' || koutsuhi === 0) {
      return null
    }
    return `￥${koutsuhi.toLocaleString()}`
  }
  private get koutsuhiSonotaStr(): string | null {
    const sonota = this.kintai?.koutsuhiSonota
    if (typeof sonota !== 'number' || sonota === 0) {
      return null
    }
    return `￥${sonota.toLocaleString()}`
  }
  /**
   * 就業形態を表示するかどうか
   */
  private get isDisplayJikanKeisanType(): boolean {
    return this.kintai.shugyouKeitaiCode
      ? this.kintai.shugyouKeitaiCode != SHUGYOU_KEITAI_IPPAN
      : false
  }
  /**
   * 休日区分の通常を表示するかどうか
   */
  public get isDisplayKyujitsuType(): boolean {
    return this.kintai.kyujitsuCode ? this.kintai.kyujitsuCode != KYUJITSU_KUBUN_TSUJO : false
  }
}
